<template>
    <Card :title="$t('labels.create_order')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-2 col-md-4">
                    <FormGroup :label="$t('labels.status')">
                        <Autocomplete
                            :url="`/projects/${$route.params.projectUuid}/crm/statuses`"
                            :model-value="orderStatus?.uuid"
                            :selected-value="orderStatus?.name"
                            @update:model-value="orderStatus = $event"
                            :query-params="{
                                orders: [
                                    {
                                        column: 'priority_order',
                                        dir: 'asc'
                                    }
                                ]
                            }"
                        >
                            <template #optionContent v-if="orderStatus">
                                <span class="badge" :style="{
                                    background: orderStatus.color,
                                    color: 'white'
                                }">{{ orderStatus.name }}</span>
                            </template>
                            <template #optionItem="{option, index}">
                                <span class="badge" :style="{
                                    background: option.color,
                                    color: 'white'
                                }">{{ option.name }}</span>
                            </template>
                        </Autocomplete>
                    </FormGroup>
                </div>
                <div class="col-lg-2 col-md-4">
                    <FormGroup :label="$t('labels.order_source')">
                        <Autocomplete
                            :url="`/projects/${$route.params.projectUuid}/crm/sources`"
                            :model-value="orderSource?.uuid"
                            :selected-value="orderSource?.name"
                            :can-be-empty="true"
                            :query-params="{
                                extra_fields: ['imageFile']
                            }"
                            @update:model-value="orderSource = $event"
                        >
                            <template #optionContent>
                                <div class="d-flex">
                                    <img class="image-preview mr-1" :src="orderSource?.image_file?.url || PLACEHOLDER_IMAGE_URL" />
                                    <span class="source-name">{{ orderSource?.name || $t('labels.empty') }}</span>
                                </div>
                            </template>
                            <template #optionItem="{option, index}">
                                <div class="d-flex">
                                    <img class="image-preview mr-1" :src="option?.image_file?.url || PLACEHOLDER_IMAGE_URL" />
                                    {{ option.name }}
                                </div>
                            </template>
                        </Autocomplete>
                    </FormGroup>
                </div>
                <div class="col-lg-2 col-md-4">
                    <FormGroup :label="$t('labels.external_id')">
                        <Input v-model="externalOrderNumber"/>
                    </FormGroup>
                </div>
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.client_comment')">
                        <Input
                            v-model="comment"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="create">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.create') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Autocomplete from "../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import Input from "../../../../components/new/form/Input.vue";
import Button from "../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../services/HttpClient";
import { PLACEHOLDER_IMAGE_URL } from "../../../constants";
export default {
    name: 'OrderCreatePage',
    components: {
        Card, FormGroup, Autocomplete, Input, Button
    },
    data() {
        return {
            PLACEHOLDER_IMAGE_URL,
            orderStatus: null,
            orderSource: null,
            externalOrderNumber: null,
            comment: ''
        }
    },
    methods: {
        create() {
            let requestData = {};

            if (this.orderStatus) {
                requestData.status_uuid = this.orderStatus.uuid;
            }
            
            if (this.comment) {
                requestData.comment = this.comment;
            }

            if (this.orderSource) {
                requestData.source_uuid = this.orderSource.uuid;
            }

            if (this.externalOrderNumber) {
                requestData.external_order_number = this.externalOrderNumber;
            }

            httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/orders`, requestData).then((response) => {
                this.$router.push({name: 'OrderProducts', params: {
                    orderUuid: response.data.data.uuid
                }})
            })
        }
    },
    mounted() {
        if (this.$route.query.orderStatusUuid) {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/statuses/${this.$route.query.orderStatusUuid}`).then((response) => {
                this.orderStatus = response.data.data
            })
        }
        if (this.$route.query.orderSourceUuid) {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/sources/${this.$route.query.orderSourceUuid}`).then((response) => {
                this.orderSource = response.data.data
            })
        }
    }
}
</script>
<style scoped>
.image-preview {
    border-radius: 5px;
    object-fit: cover;
    object-position: center;
    width: 20px;
    height: 20px;
}
</style>